<template>
    <div class="c-layout-content">
        <div class="content-main-box">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "LayoutContent",
};
</script>

<style scoped lang="less">
.c-layout-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .content-main-box {
        width: 100%;
        max-width: 1200px;
    }
}
</style>
